var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.visible ? _c('div', {
    staticClass: "common-tips-dialog",
    class: _vm.isMobile && 'common-tips-dialog-wap'
  }, [_c('div', {
    staticClass: "shadow",
    on: {
      "click": function ($event) {
        return _vm.cancelFn();
      }
    }
  }), _c('transition', {
    attrs: {
      "appear": ""
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.visible,
      expression: "visible"
    }],
    key: "dialog",
    staticClass: "dialog-main",
    style: {
      width: _vm.isMobile ? '90vw' : 'auto',
      maxWidth: _vm.isMobile ? '90vw' : 'auto',
      height: 'auto',
      borderRadius: _vm.remTran(15)
    }
  }, [_c('div', {
    staticClass: "ad-image",
    style: {
      width: _vm.isMobile ? '90vw' : 'auto',
      maxWidth: _vm.isMobile ? '90vw' : 'auto'
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.adPic
    }
  })])])])], 1) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };